import { useNavigate } from 'react-router-dom';
import FilterBar from '@/components/FilterBar';
import { DATA_FILTERS } from '@/constants/constants';

interface DataFiltersProps {
  disabled?: boolean;
  selectedOption: string;
  setSelectedOption: (option: string) => void;
}

function DataFilters({ disabled, selectedOption, setSelectedOption }: DataFiltersProps) {
  const navigate = useNavigate();

  function handleOptionChange(optionId: string | number) {
    const option = DATA_FILTERS.find((filter) => filter.id === optionId);
    if (!option) return;

    navigate(`/data/${option.id}`);
    setSelectedOption(option.id);
  }

  return (
    <FilterBar
      label='View'
      options={DATA_FILTERS}
      selectedOptionId={selectedOption}
      onOptionClick={handleOptionChange}
      disabled={disabled}
      dataCy='data-filters'
    />
  );
}

export default DataFilters;
